import React, { useState, useEffect } from 'react';
import logo from '../assets/images/logo.png';
import birds from '../assets/images/birds1.gif';

const Landing = () => {
    return (
        <section id="landing-section">
            <div id="landingText">
                <div id="logoContainer">
                    <img className="birdsOne" src={birds} alt="Birds Flying" />
                    <img className="birdsTwo" src={birds} alt="Birds Flying" />
                    <img
                        className="birdsThree"
                        src={birds}
                        alt="Birds Flying"
                    />
                    <img className="logo" src={logo} alt="ChartIt Logo" />
                </div>
                <h1 className="sr-only">ChArt It</h1>
                <p>
                    Stock, Crypto, and Forex charts programatically rendered as
                    pixel art.
                </p>
                <em>Powered by p5.js, Twelve Data, and CoinGecko</em>
                <div className="scroll-cue" aria-hidden="true">
                    <span className="scroll-cue-arrow" />
                </div>
                <a href="#info-section" className="button--block">
                    Get Started
                </a>
            </div>
        </section>
    );
};

export default Landing;
